import { Controller } from "@hotwired/stimulus";
import { Popover } from "bootstrap";
import Logger from '../lib/logger';
/**
 * Popover Controller
 * Generic controller to manage Bootstrap Popovers.
 *
 * Usage:
 * <button data-controller="popover"
 *         data-bs-toggle="popover"
 *         title="Popover Title"
 *         data-bs-content="Popover content here"
 *         data-popover-placement-value="right">...</button>
 */
class default_1 extends Controller {
    constructor() {
        super(...arguments);
        this.popover = null;
    }
    connect() {
        // Lazy initialization on first interaction or if visible
        if (this.isVisible()) {
            requestAnimationFrame(() => this.initializePopover());
        }
        else {
            this.element.addEventListener('mouseenter', () => this.initializePopover(), { once: true });
        }
    }
    isVisible() {
        return !!(this.element.offsetWidth || this.element.offsetHeight || this.element.getClientRects().length);
    }
    disconnect() {
        if (this.popover) {
            this.popover.dispose();
            this.popover = null;
        }
    }
    initializePopover() {
        try {
            const options = {
                container: this.hasContainerValue ? this.containerValue : 'body',
                trigger: this.hasTriggerValue ? this.triggerValue : 'click',
                placement: this.hasPlacementValue ? this.placementValue : 'auto',
                html: this.htmlValue
            };
            if (this.hasBoundaryValue)
                options.boundary = this.boundaryValue;
            if (this.hasTitleValue)
                options.title = this.titleValue;
            if (this.hasContentValue)
                options.content = this.contentValue;
            this.popover = new Popover(this.element, options);
        }
        catch (error) {
            Logger.error('Failed to initialize popover', error, { element: this.element });
        }
    }
    cleanup() {
        if (this.popover) {
            this.popover.dispose();
            this.popover = null;
            Logger.debug('Popover disposed', { element: this.element });
        }
    }
}
default_1.values = {
    placement: String,
    container: String,
    trigger: String,
    boundary: String,
    title: String,
    content: String,
    html: { type: Boolean, default: false }
};
export default default_1;
